import get from 'lodash.get';

const REST_OF_WORLD_REGION = 'Rest of the World';
const FREE_SHIPPING_PRICE = 0;
const JEWELRY_VERTICAL = 'jewelry';

// NOTE:
// when developing locally/QA, userRegions arg could be [] if user zipCode isn't updated to a valid one (b/c default zipCode is "0")
// we then try to use user ip address as back up but b/c private ip address when dev locally/QA we couldn't get any user geoInfo from it.

// to get around this, you have to manually set a valid zipCode (either sessionUserZipCode in Session Storage or zipCode under userGeoInfo in local storage)
export const getIsFreeShipping = ({ item, userRegions }) => {
    const userRegionNames = (userRegions || []).map(region => region.displayName).filter(Boolean);
    const shipmentQuotes = get(item, 'shipmentQuotes') || [];
    return !!shipmentQuotes.find(shipmentQuote => {
        const regionPrice = get(shipmentQuote, 'totalAmount.amount');
        const regionName = get(shipmentQuote, 'serviceMethod.region.regionName');
        const freeUserRegion =
            userRegionNames.includes(regionName) && regionPrice === FREE_SHIPPING_PRICE;
        const freeRestOfWorldRegion =
            regionName === REST_OF_WORLD_REGION && regionPrice === FREE_SHIPPING_PRICE;
        // FINDING-14549: Rest of world (ROW) shipping quotes are not considered in S/B free shipping, since items may
        // have free shiping to ROW but not to user specifict region. However, few items in jewelry fall in to that
        // situation and due to big marketing pushes around jewelry free shipping, we are temporarilyconsidering ROW quotes
        // for jewelry vertical only on the FE until we revisit how free shipping is determined.
        const isJewelry = get(item, 'vertical') === JEWELRY_VERTICAL;
        return isJewelry ? freeUserRegion || freeRestOfWorldRegion : freeUserRegion;
    });
};
